import { useState } from "react";

function NewCompetition({ competitionProps }: { competitionProps: any }) {
    const [name, setName] = useState("");
    const [english_name, setEnglishName] = useState("");
    const [minDate] = useState(new Date().toISOString().slice(0, 10));
    const [startsAt, setStartsAt] = useState();
    const [endsAt, setEndsAt] = useState("");
    const [credits, setCredits] = useState("");

    const handleNameChange = (e: any) => {
        let value = e.target.value;

        setName(value);
    }

    const handleEnglishNameChange = (e: any) => {
        let value = e.target.value;

        setEnglishName(value);
    }

    const handleStartChange = (e: any) => {
        let value = e.target.value;

        setStartsAt(value);
    }

    const handleEndChange = (e: any) => {
        let value = e.target.value;

        setEndsAt(value);
    }

    const handleCreditChange = (e: any) => {
        let value = e.target.value;

        setCredits(value);
    }

    const handleCloseEvent = () => {
        competitionProps.handleClose();
    }

    const handleSaveEvent = () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "name": name,
                "english_name": english_name,
                "starts_at_date": startsAt,
                "ends_at_date": endsAt,
                "amount_credits_won": credits
            })
        };
        fetch('/api/competitions/create', requestOptions)
            .then(response => response.json());
        
        competitionProps.handleClose();
    }

    return (
      <div className="pfgame-popup" style={{ display: (competitionProps.show) ? "flex" : "none"}}>
        <div className="pfgame-popup__form-wrapper">
            <div className="pfgame-popup__form-wrapper--header">
                Add a New Competiton
            </div>

            <div className="pfgame-popup__form-wrapper--input-zone">
                <div className="input-group">
                    <label>
                        Competition Name: 
                    </label>
                    <input name="competition_name" type="text" className="pfgame-main-input" value={name} onChange={handleNameChange} />
                </div>

                <div className="input-group">
                    <label>
                        Competition English Name: 
                    </label>
                    <input name="competition_english_name" type="text" className="pfgame-main-input" value={english_name} onChange={handleEnglishNameChange} />
                </div>
            
                <div className="input-group">
                    <label>
                        Competition Starts At
                    </label>
                    <input type="datetime-local" name="competition_start"
                        value={startsAt}
                        min={minDate} className="pfgame-main-input" onChange={handleStartChange} />
                </div>

                <div className="input-group">
                    <label>
                        Competition Ends At
                    </label>
                    <input type="datetime-local" name="competition_end"
                        value={endsAt}
                        min={minDate} className="pfgame-main-input" onChange={handleEndChange} />
                </div>

                <div className="input-group">
                    <label>
                        Credits that can be won: 
                    </label>
                    <input name="competition_name" type="number" className="pfgame-main-input" value={credits} onChange={handleCreditChange} />
                </div>

                <button className="pfgame-main-button btn-red" onClick={handleCloseEvent}>Cancel</button>
                <button className="pfgame-main-button btn-dark" onClick={handleSaveEvent}>Save</button>
            </div>
        </div>
      </div>
    );
  }

export { NewCompetition };